;

(function (window, document, $) {
  "use strict";

  $(document).ready(function ($) {
    var $btn = $('.donation-floater');
    var outerWidth = $btn.find('.donation-floater__inner').outerWidth();
    $btn.on('mouseenter', function (e) {
      $btn.css('width', outerWidth);
    });
    $btn.on('mouseleave', function (e) {
      $btn.css('width', '60px');
    });
  });
})(window, document, jQuery);
;

(function (window, document, $) {
  "use strict";

  $(document).ready(function ($) {
    $('.career-item__open').on('click', function () {
      var $parent = $(this).closest('.career-item');
      $parent.toggleClass('career-item--open');
      $parent.find('.career-item__content').slideToggle(); // seperate line

      $parent.find('.career-item__content-wrapper').toggleClass('career-item__content-wrapper--open');
    });
  });
})(window, document, jQuery);
;

(function (window, document, $) {
  "use strict";

  $(document).ready(function ($) {
    var $accordion = $('.accordion'),
        $collapse = $accordion.find('.collapse');

    var modify = function modify(open) {
      var CLASS_NAME = 'js-accordion-open';
      var $accordion = $(this).closest('.accordion');
      return open ? $accordion.addClass(CLASS_NAME) : $accordion.removeClass(CLASS_NAME);
    }; // The collapsible content is about to be shown.


    $collapse.on('show.bs.collapse', function () {
      modify.call(this, true);
    }); // The collapsible content is now fully shown.

    $collapse.on('shown.bs.collapse', function () {
      var $accordionBody = $(this).find('.accordion-body');
      setTimeout(function () {
        return $accordionBody.focus();
      }, 100);
    }); // The collapsible content is about to be hidden.

    $collapse.on('hide.bs.collapse', function () {
      modify.call(this);
    }); // The collapsible content is now hidden.

    $collapse.on('hidden.bs.collapse', function () {
      var $button = $(this);

      if (!$button.is(':focus')) {
        setTimeout(function () {
          $button.focus();
        }, 100);
      }
    });
  });
})(window, document, jQuery);
;

(function (window, document, $) {
  "use strict";

  jQuery(document).ready(function ($) {
    var $body = $('body');
    $body.on('focusin', '.gfield input', function (e) {
      var $this = $(this);
      $this.closest('.gfield').addClass('-pre-focusin');
    });
    $body.on('focusout', '.gfield input', function (e) {
      var $this = $(this);
      var value = $this.val().trim();
      var $parent = $this.closest('.gfield');

      if (value) {
        $parent.addClass('-pre-focusin');
        return;
      }

      $parent.removeClass('-pre-focusin');
    });
  });
})(window, document, jQuery);
;

(function ($) {
  "use strict";

  jQuery(document).ready(function ($) {
    var mobile = $(window).width() < 1200; // alert(mobile)
    //if (mobile) return

    if (document.querySelector('#fullpage')) {
      $('#fullpage').fullpage({
        paddingTop: mobile ? '50px' : '88px',
        navigation: true,
        verticalCentered: true,
        responsiveWidth: 800,
        //normalScrollElements: '.footer',
        //scrollOverflow: true,
        anchors: ['firstSection', 'secondSection', 'thirdSection', 'fourthSection'],
        afterRender: function afterRender() {
          // var pluginContainer = this;
          var $el = document.querySelector('.hero__content ');
          $el && $el.classList.add('hero__content--open');
        }
      });
    }

    if (document.querySelector('#fullpage-split')) {
      $('#fullpage-split').fullpage({
        navigation: true,
        verticalCentered: true,
        responsiveWidth: 800,
        anchors: ['firstSection', 'secondSection', 'thirdSection', 'fourthSection'],
        // normalScrollElements: ['.footer'],
        afterRender: function afterRender() {
          // var pluginContainer = this;
          var $el = document.querySelector('.hero__content ');
          $el && $el.classList.add('hero__content--open');
        }
      });
    } //         fullpaje scroll down


    $('.scroll-down span').each(function () {
      $(this).on('click', function () {
        jQuery.fn.fullpage.moveSectionDown();
      });
    });
  });
})(jQuery);
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function getTop() {
  return jQuery(window).scrollTop();
}

function isIE11() {
  return !!window.MSInputMethodContext && !!document.documentMode;
}

function isEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

function scroll_to(element) {
  var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var $element = jQuery(element);
  var $site_navbar = jQuery('#site_navbar');

  if ($element.length) {
    var scrollTop = $element.first().offset().top - ($site_navbar.outerHeight() + window.parseInt(distance));
    jQuery('html, body').animate({
      scrollTop: scrollTop
    }, {
      duration: 1000,
      easing: 'easeInOutExpo'
    });
  }
}

var Comp_Factory = /*#__PURE__*/function () {
  function Comp_Factory($, CLASS_NAME) {
    _classCallCheck(this, Comp_Factory);

    this.$ = $;
    this.CLASS_NAME = CLASS_NAME;
  }

  _createClass(Comp_Factory, [{
    key: "open",
    value: function open() {
      return this.$.addClass(this.CLASS_NAME);
    }
  }, {
    key: "close",
    value: function close() {
      return this.$.removeClass(this.CLASS_NAME);
    }
  }, {
    key: "toggle",
    value: function toggle() {
      return this.$.toggleClass(this.CLASS_NAME);
    }
  }, {
    key: "is_open",
    value: function is_open() {
      return this.$.hasClass(this.CLASS_NAME);
    }
  }]);

  return Comp_Factory;
}();

;

(function (window, document, $) {
  $.fn.doSlickSlide = function (direction) {
    var self = $(this),
        slickSection = self.closest('.slick-section');
    if (slickSection.length > 0) slickSection.find('.slick-slider').slick(direction);
    return this;
  };

  $('.slick-next').on('click', function () {
    $(this).doSlickSlide('slickNext');
  });
  $('.slick-prev').on('click', function () {
    $(this).doSlickSlide('slickPrev');
  });
  $.easing['jswing'] = $.easing['swing'];
  $.extend(jQuery.easing, {
    easeInOutExpo: function easeInOutExpo(x, t, b, c, d) {
      if (t == 0) return b;
      if (t == d) return b + c;
      if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
      return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
    }
  });
})(window, document, jQuery);
;

(function (window, document, $) {
  "use strict";

  jQuery(document).ready(function ($) {
    if ($(window).width() > 767) {
      // Desktop
      var parentHeight = $('.hover-list__item').outerHeight();
      var maxChildrenHeight = parentHeight;
      $('.hover-list__txt').each(function (i, el) {
        maxChildrenHeight = $(el).outerHeight() > maxChildrenHeight ? $(el).outerHeight() : maxChildrenHeight;
      });

      if (maxChildrenHeight > parentHeight) {
        $('.hover-list__item').css('height', "".concat(maxChildrenHeight + 0, "px"));
      }
    } else {
      // Mobile (accordion)
      $('.hover-list__title').on('click', function () {
        $(this).next().slideToggle();
        $(this).toggleClass('hover-list__title--active');
      });
    }
  });
})(window, document, jQuery);
;

(function (window, document, $) {
  "use strict";
})(window, document, jQuery); // color picker
(function ($) {
  var lng, lat, program, radius;
  if (!document.querySelector('.acf-map')) return;
  /**
   * initMap
   *
   * Renders a Google Map onto the selected jQuery element
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @return  object The map instance.
   */

  function initMap($el) {
    // Find marker elements within map.
    var $markers = $el.find('.marker'); // Create gerenic map.

    var mapArgs = {
      zoom: $el.data('zoom') || 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    var map = new google.maps.Map($el[0], mapArgs); // Add markers.

    map.markers = [];
    $markers.each(function () {
      initMarker($(this), map);
    }); // Center map based on markers.

    centerMap(map); // Return map instance.

    return map;
  }
  /**
   * initMarker
   *
   * Creates a marker for the given jQuery element and map.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @param   object The map instance.
   * @return  object The marker instance.
   */


  var sharedinfoWindow = new google.maps.InfoWindow({
    content: ''
  });

  function initMarker($marker, map) {
    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng)
    };
    var programs = $marker.data('programs').toString(); // Create marker instance.

    var marker = new google.maps.Marker({
      position: latLng,
      map: map,
      icon: siteData.mapMarker,
      programs: programs.split(','),
      animation: google.maps.Animation.DROP
    }); // Append to reference for later use.

    map.markers.push(marker); // If marker contains HTML, add it to an infoWindow.

    if ($marker.html()) {
      // Create info window.
      var infowindow = sharedinfoWindow; // Show info window when marker is clicked.

      google.maps.event.addListener(marker, 'click', function () {
        infowindow.setContent($marker.html());
        infowindow.open(map, marker);
      });
    }
  }
  /**
   * centerMap
   *
   * Centers the map showing all markers in view.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   object The map instance.
   * @return  void
   */


  function centerMap(map) {
    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng()
      });
    }); // Case: Single marker.

    if (map.markers.length == 1) {
      map.setCenter(bounds.getCenter()); // Case: Multiple markers.
    } else {
      map.fitBounds(bounds);
    }
  } // Render maps on page load.


  $(document).ready(function () {
    var map;
    $('.acf-map').each(function () {
      map = initMap($(this));
    });
    var self = this;
    $('#branches-form').on('submit', function (e) {
      e.preventDefault();
      var formData = $(this).serializeArray();
      radius = parseFloat(formData.find(function (el) {
        return el.name === 'radius';
      }).value) * 1000;
      program = formData.find(function (el) {
        return el.name === 'program';
      }).value;
      map.markers.forEach(function (marker) {
        /**
         * Filter by radius and by program
         * */
        var distance = google.maps.geometry.spherical.computeDistanceBetween(marker.position, new google.maps.LatLng(lat, lng));

        if (distance > radius || !marker.programs.includes(program) && program !== '') {
          marker.setMap(null);
        } else {
          marker.setMap(map);
        } //
        // console.log('UP', typeof program) // User program
        // console.log('MP', typeof marker.programs) // Marker program from the CPT
        // if (program !== '' && marker.programs.length) {
        //     // if not contains remove
        //     if (!marker.programs.includes(program)) marker.setMap(null)
        //     else marker.setMap(map)
        //
        // }

      });
    });
  });
  var input = document.querySelector('#location-input');
  var autocomplete = new google.maps.places.Autocomplete(input);
  autocomplete.addListener("place_changed", fillInAddress);

  function fillInAddress() {
    // Get the place details from the autocomplete object.
    var place = autocomplete.getPlace();
    lng = place.geometry.location.lng();
    lat = place.geometry.location.lat();
  }
})(jQuery);
jQuery(document).ready(function ($) {
  var isMobile = window.innerWidth < 800;
  $('.header-menu > li > a').on('click', function (e) {// e.preventDefault()
  });
}(jQuery));
;

(function (window, document, $) {
  "use strict";

  $(document).ready(function ($) {
    // const $modal_member = $('.modal--member');
    //
    // // 	Occurs when the modal is about to be shown
    // $modal_member.on('  &:hover {\n' +
    //     '    background-image: linear-gradient(to left, lighten($color-gradiant-start, 10%), lighten($color-gradiant-end, 10%));\n' +
    //     '  }', function(){
    //     const id = $(this).attr('id');
    //     const $toggle = $(`[href="#${id}"]`);
    //     $toggle.addClass('js-open')
    // });
    //
    //
    // // Occurs when the modal is about to be hidden
    // $modal_member.on('hide.bs.modal', function(){
    //     const id = $(this).attr('id');
    //     const $toggle = $(`[href="#${id}"]`);
    //     $toggle.removeClass('js-open')
    // });

    /**
     *  YouTube
     * */
    var videoId = '';
    var partnerInfo = '';
    var partnerIcon = '';
    $('.open-modal').on('click', function (e) {
      e.preventDefault();
      var modalContent = $(this).data('modal-content');
      $('.modal-content-type').css('display', 'none');
      $(".modal-content-type[data-modal-content=\"".concat(modalContent, "\"]")).css('display', 'block');
      videoId = this.dataset.videoId;
      $('.modal-dialog--fixed-width').removeClass('modal-dialog--fixed-width modal-dialog--small');

      if (modalContent === 'pi') {
        partnerInfo = this.querySelector('.hidden').innerHTML;
        partnerIcon = this.querySelector('img').src;
      }

      $('.modal').modal('show', modalContent);
    });
    $(".modal").on('show.bs.modal', function (e) {
      var modalContent = e.relatedTarget;

      if (modalContent === 'yt') {
        // inject id
        var iframe = this.querySelector('iframe');
        iframe.src = "https://www.youtube.com/embed/".concat(videoId, "?autoplay=1");
      } else if (modalContent === 'nl') {
        $('.modal-dialog').addClass('modal-dialog--fixed-width');
      } else if (modalContent === 'pi') {
        $('.modal-dialog').addClass('modal-dialog--small');
        $('.partner-info').html("<img src=\"".concat(partnerIcon, "\" /><p>").concat(partnerInfo, "</p>"));
      }
    });
    $(".modal").on('hide.bs.modal', function () {
      var iframe = this.querySelector('iframe');
      iframe.src = "";
    });
    /**
     * Newsletter
     */
    // $('.open-newsletter').on('click', function (e) {
    //     e.preventDefault()
    //     // hide iframe
    //     $('.modal-dialog').addClass('modal-dialog--fixed-width')
    //     $('.modal .youtube-wrapper').css('display', 'none')
    //     $('.modal .newsletter').css('display', 'block')
    //     // show form
    //     // open modal
    //     $('.modal').modal('show')
    // })

    $('.close').on('click', function () {
      $('.modal').modal('hide');
    });
  });
})(window, document, jQuery);
function createRipple(e) {
  var _this = this;

  // Create new ripple element
  var ripple = document.createElement('div');
  ripple.style.position = 'absolute'; // Append child element

  this.appendChild(ripple); // The inner width of an element in pixels.
  // It includes padding but excludes borders, margins, and vertical scrollbars

  var btnWidth = this.clientWidth;
  var btnHeight = this.clientHeight; // Returns the largest of zero or more numbers

  var dimension = Math.max(btnWidth, btnHeight); // Because our buttons are not square but rectangels we need to set their width and height to be same

  ripple.style.width = ripple.style.height = dimension + 'px'; // Returns the size of an element and its position relative to the viewport

  var rect = this.getBoundingClientRect(); // Holds the coordinates of the mouse pointer when the mouse button is clicked

  var clickedPosition = {
    x: e.clientX,
    y: e.clientY
  }; // Set Ripple X Y edge position

  ripple.style.left = clickedPosition.x - rect.left - dimension / 2 + 'px';
  ripple.style.top = clickedPosition.y - rect.top - dimension / 2 + 'px'; // Add .ripple class to create ripple animation

  ripple.classList.add('-pre-ripple'); // Remove Ripple from his parent element

  setTimeout(function () {
    return _this.removeChild(ripple);
  }, 2000);
}
;

(function (window, document, $) {
  "use strict";

  $(document).ready(function ($) {
    var selectors = ".btn, .header-menu-icon-wrapper, .header__icons i, .play";
    $(selectors).on('mouseenter', function (e) {
      createRipple.call(this, e);
    }); // $('.header-menu-icon-wrapper').on('mouseenter', function (e) {
    //     createRipple.call(this, e)
    // })
  });
})(window, document, jQuery);
jQuery(document).ready(function ($) {
  var isMobile = window.innerWidth < 800; //if (!isMobile) return
  // main menu

  var $icon = $('.header .fa-search');
  $icon.on('click', function () {
    var $el = $('.header-search');
    $el.toggleClass('header-search--open'); // focus

    $el.find('input[type="text"]').focus();
  });
}(jQuery));
jQuery(document).ready(function ($) {
  // add prev item to secondary (About) menu
  $('.about-menu .sub-menu').each(function () {
    var text = $(this).parent('li').find('a')[0].innerText;
    $(this).prepend("<li class=\"about-menu__back\">".concat(text, "</li>"));
  }); // go back

  $('.about-menu__back').on('click', function (e) {
    e.stopPropagation();
    $el = $(this).closest('.sub-menu');
    $el[0] && $el[0].classList.remove('sub-menu--active');
  }); // secondary menu (about)

  var $sIcon = $('.header-menu-icon-wrapper');
  $sIcon.on('click', function () {
    $el = $('.about-menu__wrapper');
    $el.toggleClass('about-menu__wrapper--active');
    $('body').toggleClass('prevent-scroll');
  });
  var $closeBtn = $('.about-menu__close i');
  $closeBtn.on('click', function () {
    $el = $('.about-menu__wrapper');
    $el.toggleClass('about-menu__wrapper--active'); // reset menu

    $.each($(".about-menu__wrapper .sub-menu--active"), function () {
      this.classList.remove('sub-menu--active');
    });
    $('body').toggleClass('prevent-scroll');
  });
  var $elWithChildren = $('.about-menu .menu-item-has-children');
  $elWithChildren.on('click', function (e) {
    //e.preventDefault()
    var $child = $(this).find('>.sub-menu');
    $child.addClass('sub-menu--active');
  });
  /**
   * Program nav
   */

  $(".program-nav__item a").click(function (e) {
    e.preventDefault();
    var selector = this.href.substring(this.href.indexOf('#') // '#foo'
    );
    $([document.documentElement, document.body]).animate({
      scrollTop: $(selector).offset().top - 100
    }, 800); // $(selector).scroll();
  });
});
;

(function (window, document, $) {
  "use strict";

  jQuery(document).ready(function ($) {
    var isMobile = window.innerWidth < 800;
    var defaults = {
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      focusOnSelect: true,
      infinite: true,
      arrows: isMobile ? false : true,
      autoplay: false,
      rtl: aluma_is_rtl(),
      fade: false,
      cssEase: 'linear'
    };
    var breakpoint = {
      sm: 768,
      md: 992,
      lg: 1200,
      xl: 1600
    };

    var setBreakpoint = function setBreakpoint(breakpoint, settings) {
      --breakpoint;
      return {
        breakpoint: breakpoint,
        settings: settings
      };
    };

    var unslick = function unslick(breakpoint) {
      return setBreakpoint(breakpoint, 'unslick');
    };

    var setSlick = function setSlick(selector, _ref) {
      var defaults = _ref.defaults,
          options = _ref.options;
      return $(selector).slick($.extend({}, defaults, options));
    };

    {
      var options = {
        centerPadding: '30px',
        slide: '.updates-grid__item',
        centerMode: true,
        responsive: [unslick(breakpoint.sm)]
      };
      setSlick('.updates:not(.updates--simple) .updates-grid', {
        defaults: defaults,
        options: options
      });
    }
    {
      var _options = {
        slide: '.packages-intro-grid__item',
        dots: true,
        responsive: [unslick(breakpoint.sm)]
      };
      setSlick('.packages-intro-grid', {
        defaults: defaults,
        options: _options
      });
    }
    {
      var _options2 = {
        slide: '.our-partners-grid__item',
        centerMode: true,
        slidesToShow: 2,
        responsive: [unslick(breakpoint.sm)]
      };
      setSlick('.our-partners-grid', {
        defaults: defaults,
        options: _options2
      }).slick('slickGoTo', 1);
    }
    {
      var _options3 = {
        slide: '.testimonials-grid__item',
        centerMode: true,
        slidesToShow: 1,
        responsive: [unslick(breakpoint.sm)]
      };
      setSlick('.testimonials-grid', {
        defaults: defaults,
        options: _options3
      });
    }
    {
      var _options4 = {
        slide: '.front-gallery__slide',
        centerMode: true,
        slidesToShow: isMobile ? 2.5 : 5.3 //responsive: [ unslick( breakpoint.sm ) ]

      };
      setSlick('.front-gallery__slider', {
        defaults: defaults,
        options: _options4
      });
    }
    {
      var _options5 = {
        slide: '.info-slider__slide',
        centerMode: true,
        slidesToShow: 1,
        dots: true
      };
      setSlick('.info-slider', {
        defaults: defaults,
        options: _options5
      });
    }
    {
      var _options6 = {
        slide: '.testimonial-slider__slide',
        //centerMode: true,
        //slidesToShow: 1,
        arrows: true
      };
      setSlick('.testimonial-slider', {
        defaults: defaults,
        options: _options6
      });
    }
    $(".lightgallery").lightGallery({
      thumbnail: true
    });
  });
})(window, document, jQuery);